// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__etw0u","contentWrapper":"styles_contentWrapper__1rui8","content":"styles_content__xI0lf"};